import { getImgxUrl } from "../LazyImage/index.js";
import { KDEFAULT_AVATAR_PATH, KDEFAULT_AVATAR_URL, KSIZE_MAPPER } from "./constants.js";
const getAvatarSrc = ({ src: srcProp, size: sizeProp })=>{
    if (!srcProp) return {};
    const baseImgxParams = {
        auto: 'format',
        crop: 'faces',
        dpr: 2
    };
    const size = KSIZE_MAPPER[sizeProp];
    return {
        src: getImgxUrl(srcProp, {
            w: size,
            h: size,
            ...baseImgxParams
        })
    };
};
const getDefaultAvatarSrc = ({ defaultAvatarColor: color, size: sizeProp })=>{
    const size = KSIZE_MAPPER[sizeProp];
    const baseUrl = KDEFAULT_AVATAR_URL + KDEFAULT_AVATAR_PATH[color];
    return getImgxUrl(baseUrl, {
        w: size,
        h: size
    });
};
export { getAvatarSrc, getDefaultAvatarSrc };
